export const jackpotDrawerController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isJackpotDrawerPage',
          actions: ['setBodyNonScrollable'],
        },
      },
    },
    on: {
      initial: 'layoutReloader',
      states: {
        layoutReloader: {
          initial: 'reloading',
          states: {
            idle: {
              on: {
                RELOAD_CATEGORIES: 'reloading',
              },
            },
            reloading: {
              invoke: {
                src: 'getJackpotDrawerLayoutContent',
                onDone: {
                  target: 'idle',
                },
              },
            },
          },
        },
      },
      on: {
        ROUTE_CHANGED: {
          target: 'off',
          actions: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.JackpotDrawer.properties.games',
                value: [],
              },
            },
          ],
        },
      },
    },
  },
};
